import React from 'react';
import { TrashIcon } from '@radix-ui/react-icons';

import { ActionBox, Cell, Row } from '../../../components/settings-table/styled-table';
import { DropdownMenu, Item } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { formatDate } from '../../../lib/utils/DateHelper';
import { dateShort } from '../../../assets/contants/dates-fns';
import { ApiKey } from '../store/api-key.slice';

type ApiKeyItemProps = {
  apiKey: ApiKey;
  onRevoke: (apiKeyId: string) => void;
};

export const ApiKeyItem: React.FC<ApiKeyItemProps> = ({ apiKey, onRevoke }) => {
  const menuItems: Item[] = [
    {
      title: 'Revoke',
      onSelect: () => onRevoke(apiKey._id),
      type: 'danger',
      icon: <TrashIcon />,
    },
  ];

  return (
    <Row>
      <Cell>{apiKey.name}</Cell>
      <Cell>{apiKey.prefix}•••••••••</Cell>
      <Cell>{formatDate(apiKey.createdAt, dateShort)}</Cell>
      <Cell>{apiKey.lastUsedAt ? formatDate(apiKey.lastUsedAt, dateShort) : 'Never'}</Cell>
      <ActionBox>
        <DropdownMenu items={menuItems} />
      </ActionBox>
    </Row>
  );
};
